const initialState = {
  step: 0, // 0 = Start Page
  score: 0,
  answers: [],
  gameCompleted: false,
  timePerQuestion: 20, // seconds
  pointsPerQuestion: 10,
  questions: [],
  isFetching: false,
  error: null,
}

export default function gameReducer(state = initialState, action) {
  switch (action.type) {
    case 'NEXT_STEP':
      return {
        ...state,
        step: state.step + 1,
      }
    case 'SET_SCORE':
      return {
        ...state,
        score: action.payload,
      }
    case 'SET_STEP':
      return {
        ...state,
        step: action.payload,
      }
    case 'SET_GAME_COMPLETED':
      return {
        ...state,
        gameCompleted: action.payload,
      }
    default:
      return state
  }
}

export function nextStep() {
  return {
    type: 'NEXT_STEP',
  }
}

export function setScore(score) {
  return {
    type: 'SET_SCORE',
    payload: score,
  }
}

export function setStep(step) {
  return {
    type: 'SET_STEP',
    payload: step,
  }
}

export function setGameCompleted(completed) {
  return {
    type: 'SET_GAME_COMPLETED',
    payload: completed,
  }
}
